import _objectSpread from "@babel/runtime/helpers/esm/objectSpread";
import { mapGetters } from 'vuex';
import getJsonLD, { TYPES } from '~/helpers/json-ld';
const getHomepageJsonLD = getJsonLD(TYPES.HOMEPAGE);
export default {
  name: 'HomepageJsonLD',
  props: {
    prismic: {
      type: Object,
      required: true
    }
  },
  computed: _objectSpread({}, mapGetters({
    locale: 'i18n/locale',
    url: 'request/baseURL'
  }), {
    scriptJsonLD() {
      const prismic = _objectSpread({}, this.prismic, {
        url: this.url
      });

      return {
        type: 'application/ld+json',
        innerHTML: JSON.stringify(getHomepageJsonLD(prismic, this.locale)),
        body: true
      };
    }

  }),

  head() {
    return {
      script: [this.scriptJsonLD]
    };
  },

  render: h => h(null)
};